import axios from 'axios'
import store from './index'

const STREAM_LOCAL_AUTH = 'stream_local_auth'

export default {
  getAuthOnPage () {
    return localStorage.getItem(STREAM_LOCAL_AUTH)
  },
  setAuthOnPage (authToken) {
    localStorage.setItem(STREAM_LOCAL_AUTH, authToken)
  },
  removeAuthOnPage () {
    localStorage.removeItem(STREAM_LOCAL_AUTH)
  },
  getAuthHeader () {
    return {'headers': {'Authorization': store.state.profile.loginToken}}
  },
  getAuthReplayable (actionData) {
    return Object.assign(this.getAuthHeader(), {actionData})
  },
  getUrl (uri) {
    return `${store.state.config.baseUrl}:${store.state.config.port}` + uri
  },
  unauthPost (uri, data, success, failure) {
    let request = axios.post(this.getUrl(uri), data)
      .then(function (response) {
        success(response)
      })
      .catch(function (error) {
        console.log('error ', error)
        console.log('req ', request)
        failure()
      })
  },
  get (uri) {
    return axios.get(this.getUrl(uri), this.getAuthHeader())
  },
  getReplayable (uri, actionData) {
    return axios.get(this.getUrl(uri), this.getAuthReplayable(actionData))
  },
  put (uri, data) {
    return axios.put(this.getUrl(uri), data, this.getAuthHeader())
  },
  putReplayable (uri, data, actionData) {
    return axios.put(this.getUrl(uri), data, this.getAuthReplayable(actionData))
  },
  post (uri, data) {
    return axios.post(this.getUrl(uri), data, this.getAuthHeader())
  },
  postReplayable (uri, data, actionData) {
    return axios.post(this.getUrl(uri), data, this.getAuthReplayable(actionData))
  }
}



// WEBPACK FOOTER //
// ./src/store/server.js